import axios from "axios";
import { API_BASE_URL } from "@/utils/apiBase";
import { clearAuth, getAuthToken } from "@/utils/authStorage";

export const customAxios = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

customAxios.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

customAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      clearAuth();
      // Hash-mode router: jump to /login without a full reload.
      if (!/(^|\/)login$/.test(window.location.hash)) {
        window.location.hash = "#/login";
      }
    }
    return Promise.reject(error);
  }
);
